import axios from "axios";
import { useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const prefersReduced = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (id === "home") {
    window.scrollTo({ top: 0, behavior: prefersReduced() ? "auto" : "smooth" });
    return;
  }
  el.scrollIntoView({ behavior: prefersReduced() ? "auto" : "smooth", block: "start" });
};

export const useMediaQuery = (query) => {
  const [match, setMatch] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return match;
};

export const useLiteMotion = () => {
  const reduced = useMediaQuery("(prefers-reduced-motion: reduce)");
  const mobile = useMediaQuery("(max-width: 767px)");
  return reduced || mobile;
};

export const useWhatsApp = () => {
  const [number, setNumber] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/config`)
      .then((r) => setNumber(r.data.whatsapp_number || null))
      .catch(() => setNumber(null));
  }, []);
  return number;
};
